import { api } from '@creditsights/api-ui-web';
import { FundamentalMetricsDto } from './dtos/fundamentalMetrics.dto';

const riskProductsUri = '/risk-products/v1';
export const getFundamentalUrl = (companyId: string): string => `${riskProductsUri}/company/${companyId}/fundamental`;

export const fetchCompanyFundamental = async (companyId: string): Promise<FundamentalMetricsDto> => {
  const resp = await api.get(getFundamentalUrl(companyId));
  return resp?.data;
};
